import type { WorkspaceTab } from "./components/MainNav";

export function isDebriefPath(pathname = window.location.pathname): boolean {
  const path = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  return path === "/debrief" || path.startsWith("/debrief/");
}

export function isKioskBoot(pathname = window.location.pathname, search = window.location.search): boolean {
  const path = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  const params = new URLSearchParams(search);
  return params.get("kiosk") === "1" || path === "/kiosk" || path.startsWith("/kiosk/");
}

export function tabFromPath(pathname = window.location.pathname): WorkspaceTab {
  const path = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  if (path === "/contacts" || path.endsWith("/contacts")) return "contacts";
  if (path === "/campaigns" || path.startsWith("/campaigns/")) return "campaigns";
  if (
    path === "/floor" ||
    path === "/floorwalker" ||
    path.endsWith("/floor") ||
    path.endsWith("/floorwalker")
  ) {
    return "floor";
  }
  if (path === "/profile" || path.endsWith("/profile")) return "profile";
  return "account";
}

export function pathFromTab(tab: WorkspaceTab): string {
  switch (tab) {
    case "contacts":
      return "/contacts";
    case "campaigns":
      return "/campaigns";
    case "floor":
      return "/floor";
    case "profile":
      return "/profile";
    default:
      return "/";
  }
}
